// @noflow

import Warning from './warning.jsx';


export default Warning;
